(() => {
  const EXTERNAL_HOSTNAMES = new Set([
    'recrutement.theodoremaisondepeinture.fr',
    'magasin.theodore-peinture.fr',
    'www.monsieurpeinture.com',
  ]);

  const applyExternalLinkTargets = (root = document) => {
    root.querySelectorAll('a[href]').forEach((link) => {
      try {
        const url = new URL(link.href, window.location.href);

        if (!EXTERNAL_HOSTNAMES.has(url.hostname)) return;

        link.target = '_blank';
        link.rel = 'noopener noreferrer';
      } catch (_) {
        // Ignore malformed or non-standard URLs.
      }
    });
  };

  const boot = () => {
    applyExternalLinkTargets();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;

          if (node.matches?.('a[href]')) {
            applyExternalLinkTargets(node.parentElement || document);
            return;
          }

          if (node.querySelector?.('a[href]')) {
            applyExternalLinkTargets(node);
          }
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
